import { render, staticRenderFns } from "./external.vue?vue&type=template&id=10ea4ff3&scoped=true"
import script from "./external.vue?vue&type=script&lang=js"
export * from "./external.vue?vue&type=script&lang=js"
import style0 from "./external.vue?vue&type=style&index=0&id=10ea4ff3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ea4ff3",
  null
  
)

export default component.exports